import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import vi from './locales/vi.json';
import kr from './locales/kr.json';

const resources = {
  en: {
    translation: en,
  },
  vi: {
    translation: vi,
  },
  kr: {
    translation: kr
  }
} as any;

const LANGUAGE_PERSIST_KEY = '_app_locale_key'

export const languagePersistLayer = window.localStorage;

export const changeLanguage = (lng:string) => {
  i18n.changeLanguage(lng).then(() => {
    languagePersistLayer.setItem(LANGUAGE_PERSIST_KEY, lng)
  })
}

export default {
  init: () => {
    i18n.use(initReactI18next).init({
      resources,
      lng: languagePersistLayer.getItem(LANGUAGE_PERSIST_KEY) || 'en',
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
      },
    });
  },
};
